module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "toolbar": ""
    }
  }, [_c('v-navigation-drawer', {
    attrs: {
      "temporary": "",
      "dark": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-toolbar', {
    staticClass: "transparent",
    attrs: {
      "flat": ""
    }
  }, [_c('v-list', {
    staticClass: "pa-0"
  }, [_c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-list-tile-avatar', [_c('img', {
    attrs: {
      "src": "/static/images/bluecoders.png"
    }
  })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("BlueCoders")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    staticClass: "pt-0",
    attrs: {
      "dense": ""
    }
  }, [_c('v-divider'), _vm._v(" "), _vm._l((_vm.locals), function(local) {
    return _c('v-list-tile', {
      key: local.title,
      attrs: {
        "href": local.link
      }
    }, [_c('v-list-tile-action', [_c('icon', {
      attrs: {
        "name": local.icon
      }
    })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(local.title))])], 1)], 1)
  }), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.title,
      attrs: {
        "href": item.link,
        "target": _vm.getTarget(item)
      }
    }, [_c('v-list-tile-action', [_c('icon', {
      attrs: {
        "name": item.icon
      }
    })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.title))])], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "fixed": ""
    }
  }, [_c('span', {
    staticClass: "hidden-md-and-up"
  }, [_c('v-toolbar-side-icon', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  })], 1), _vm._v(" "), _c('v-toolbar-title', [_c('router-link', {
    staticClass: "title",
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("BLUECODERS - Go Cloud & AI with us")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _vm._l((_vm.locals), function(local) {
    return _c('v-toolbar-items', {
      key: local.title,
      staticClass: "hidden-sm-and-down",
      attrs: {
        "href": local.link
      }
    }, [_c('v-btn', {
      attrs: {
        "href": local.link
      }
    }, [_vm._v(_vm._s(local.title))])], 1)
  }), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('v-toolbar-items', {
      key: item.title,
      staticClass: "hidden-sm-and-down",
      attrs: {
        "href": item.link
      }
    }, [_c('v-btn', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:bottom",
        value: ({
          html: item.title
        }),
        expression: "{ html: item.title }",
        arg: "bottom"
      }],
      attrs: {
        "href": item.link,
        "target": "_blank"
      }
    }, [_c('icon', {
      attrs: {
        "name": item.icon,
        "scale": "2",
        "ripple": ""
      }
    })], 1)], 1)
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ceaf69a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Topbar.vue
// module id = 827
// module chunks = 1